export default {

  dashboardTitle: "داشبورد",
  welcomeMessage: "خوش آمدید",
  usersCount: "کاربران",
  pendingOrders: "سفارشات معلق",
  invoices: "فاکتورها",
  lowStock: "موجودی کم",
  ordersChartTitle: "سفارشات ۱۰ روز اخیر"

}
